module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "m-footer"
  }, [_c('div', {
    staticClass: "m-footer__sponsors"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-4 text-center"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('portal.contributors')) + "\n          "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "m-footer__sponsor",
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "src": _vm.$config.imgDir + '/logo-mctic.png',
      "alt": "Ministério da Ciência, Tecnologia, Inovações e Comunicações"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4 text-center"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('portal.project')) + "\n          "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "m-footer__sponsor",
    attrs: {
      "src": _vm.$config.imgDir + '/Logo-NTG.png',
      "alt": "Núcleo de Tecnologias de Gestão – NTG"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "m-footer__sponsor",
    attrs: {
      "src": _vm.$config.imgDir + '/logo-com-inscricao.png',
      "alt": "Universidade Federal de Viçosa - UFV"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4 text-center"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('portal.development')) + "\n          "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "vertical-align": "middle",
      "display": "inline-block",
      "float": "none"
    }
  }, [_c('img', {
    staticClass: "m-footer__sponsor",
    staticStyle: {
      "height": "22px"
    },
    attrs: {
      "src": _vm.$config.imgDir + '/jungle.png',
      "alt": "Jungle"
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-faead348","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/portal/Footer.vue
// module id = 780
// module chunks = 1